var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "application", on: { click: _vm.hideSearch } },
    [
      _vm.isNotPublicAccess
        ? [_c("element-header", { ref: "mainHeader" })]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [_c("router-view", { key: _vm.$route.fullPath })],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }